import { render } from "./achievementDetail.vue?vue&type=template&id=0ba62d36&scoped=true"
import script from "./achievementDetail.vue?vue&type=script&lang=js"
export * from "./achievementDetail.vue?vue&type=script&lang=js"

import "./achievementDetail.vue?vue&type=style&index=0&id=0ba62d36&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba62d36"]])

export default __exports__